import { render, staticRenderFns } from "./GenericIFrame.vue?vue&type=template&id=04e49cff&"
import script from "./GenericIFrame.vue?vue&type=script&lang=js&"
export * from "./GenericIFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports